import { render, staticRenderFns } from "./form-family-sick.vue?vue&type=template&id=b180b984&scoped=true&"
import script from "./form-family-sick.vue?vue&type=script&lang=js&"
export * from "./form-family-sick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b180b984",
  null
  
)

export default component.exports